export const isPdf = (u) => typeof u === "string" && u.toLowerCase().endsWith(".pdf");
